import { useMount, useTimeout, useUnmount } from '@lilib/hooks';
import { Box, Paper } from '@mui/material';
import { ReactNode, useState } from 'react';

const DelayedPaper = ({
  children,
  delay = 500,
}: {
  children: ReactNode;
  delay?: number;
}) => {
  const [show, setShow] = useState(false);
  const [start, cancel] = useTimeout(() => setShow(true), delay ?? 500);

  useMount(() => start());
  useUnmount(() => cancel());

  return show ? (
    <Box display="flex" flex={1} justifyContent="center" alignItems="center">
      <Paper sx={{ p: 3 }}>{children}</Paper>
    </Box>
  ) : null;
};

export default DelayedPaper;
